import 'babel-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'



// ********************
// common
// ********************

import config from '@/store/common/config'
import auth from '@/store/common/auth'
import meta from '@/store/common/meta'
import core from '@/store/common/core'
import permission from '@/store/common/permission'
import admp from '@/store/common/admp'



// ********************
// view
// ********************

// ダッシュボード
import dashboard from '@/store/views/dashboard'

// サービス管理
import service from '@/store/views/service'
import serviceForm from '@/store/views/serviceForm'
// サービス管理 : ファイル管理
import file from '@/store/views/file'
// サービス管理 : Bot管理
import bot from '@/store/views/bot'
// 202304 サービス管理に「外部パートナー連携」メニューを追加 ST
// サービス管理 : 外部パートナー連携
import partner from '@/store/views/partner'
import partnerForm from "@/store/views/partnerForm";
// 202304 サービス管理に「外部パートナー連携」メニューを追加 ED

// サービス詳細
import serviceDetail from '@/store/views/serviceDetail'
// サービス詳細 : 配信期間設定
import serviceDeliveryTerm from '@/store/views/serviceDeliveryTerm'
import serviceDeliveryTermDetail from '@/store/views/serviceDeliveryTermDetail'
// サービス詳細 : 属性設定
import serviceAttribute from '@/store/views/serviceAttribute'
import serviceAttributeDetail from '@/store/views/serviceAttributeDetail'
// サービス詳細 : 機能設定
import serviceFunction from '@/store/views/serviceFunction'
import serviceFunctionDetail from '@/store/views/serviceFunctionDetail'
// サービス詳細 : 機能設定（リンク集カテゴリ）
import serviceLinkCategory from '@/store/views/serviceLinkCategory'
// サービス詳細 : メルマガ設定
import serviceMailMagazine from '@/store/views/serviceMailMagazine'
// サービス詳細 : 連携CMS設定
import serviceLinkedCms from '@/store/views/serviceLinkedCms'
// サービス詳細 : RSS設定
import serviceRss from '@/store/views/serviceRss'
// サービス詳細 : Dropbox設定
import serviceDropbox from '@/store/views/serviceDropbox'
// サービス詳細 : コンテンツ設定
import serviceContentsSetting from '@/store/views/serviceContentsSetting'
import serviceContentsSettingForm from '@/store/views/serviceContentsSettingForm'
import serviceScreenSetting from '@/store/views/serviceScreenSetting'
import serviceScreenSettingForm from '@/store/views/serviceScreenSettingForm'

// サービス詳細 : コンテンツ適用
import serviceContentsApply from '@/store/views/serviceContentsApply'

// マスタ管理
import deliveryTypeMst from '@/store/views/deliveryTypeMst'
import noticeTypeMst from '@/store/views/noticeTypeMst'
import linkedCmsMst from '@/store/views/linkedCmsMst'
import screenConfigMst from '@/store/views/screenConfigMst'
import screenIdMst from '@/store/views/screenIdMst'
import spAppMst from '@/store/views/spAppMst'

// アカウント管理
import user from '@/store/views/user'
import userForm from '@/store/views/userForm'

// お知らせ管理
import notice from '@/store/views/notice'
import noticeForm from '@/store/views/noticeForm'
import noticeDetail from '@/store/views/noticeDetail'
import noticeList from '@/store/views/noticeList'

// ログ管理
import log from '@/store/views/log'
import logDownload from '@/store/views/logDownload'

// ADMP連携管理
import tenant from '@/store/views/tenant'
import tenantDetail from '@/store/views/tenantDetail'
import community from '@/store/views/community'
import communityDetail from '@/store/views/communityDetail'
import communityLocation from '@/store/views/communityLocation'
import device from '@/store/views/device'

// ささえiでんわ管理
import videoChat from '@/store/views/videoChat'

// ロケーション管理
import location from '@/store/views/location'

// お知らせ配信管理
import noticeCheck from '@/store/views/noticeCheck'

// core
import myAccount from '@/store/views/myAccount'
import signin from '@/store/views/signin'
import password from '@/store/views/password'
import register from '@/store/views/register'



// ********************
// components
// ********************

// dialog
import toast from '@/store/components/dialog/toast'
import confirm from '@/store/components/dialog/confirm'
import alert from '@/store/components/dialog/alert'
import error from '@/store/components/dialog/error'

// modal : ダッシュボード
import dashboardRegistAdminNoticeModal from '@/store/components/modal/dashboardRegistAdminNoticeModal'
import dashboardConfirmAdminNoticeModal from '@/store/components/modal/dashboardConfirmAdminNoticeModal'
// modal : マスタ管理
import selectNoticeTypeMstModal from '@/store/components/modal/selectNoticeTypeMstModal'
import selectServiceTypeModal from '@/store/components/modal/selectServiceTypeModal'
import selectScreenIdMstModal from '@/store/components/modal/selectScreenIdMstModal'
// modal : サービス管理 : core
import selectFileModal from '@/store/components/modal/selectFileModal'
import selectServiceScreenModal from '@/store/components/modal/selectServiceScreenModal'
import selectServiceDeliveryTypeModal from '@/store/components/modal/selectServiceDeliveryTypeModal'
import selectServiceNoticeTypeModal from '@/store/components/modal/selectServiceNoticeTypeModal'
import selectServiceRssModal from '@/store/components/modal/selectServiceRssModal'
import selectVideoChatModal from '@/store/components/modal/selectVideoChatModal'
// modal : サービス管理 :
import serviceRegistDeliveryTypeModal from '@/store/components/modal/serviceRegistDeliveryTypeModal'
import serviceRegistAttributeGroupModal from '@/store/components/modal/serviceRegistAttributeGroupModal'
import serviceSelectFunctionModal from '@/store/components/modal/serviceSelectFunctionModal'
import serviceRegistMailMagazineModal from '@/store/components/modal/serviceRegistMailMagazineModal'
// modal : サービス管理 : サービスコンテンツ設定
import serviceContentsCopyModal from '@/store/components/modal/serviceContentsCopyModal'
import serviceContentsRegistSnapshotModal from '@/store/components/modal/serviceContentsRegistSnapshotModal'
import serviceContentsRegistScreenModal from '@/store/components/modal/serviceContentsRegistScreenModal'
import serviceContentsRegistKeyAssignModal from '@/store/components/modal/serviceContentsRegistKeyAssignModal'
import selectServiceContentsScreenModal from '@/store/components/modal/selectServiceContentsScreenModal'
// modal : サービス管理 : 適用コンテンツ設定
import serviceContentsApplyConfirmModal from '@/store/components/modal/serviceContentsApplyConfirmModal'
import serviceContentsApplyRegistModal from '@/store/components/modal/serviceContentsApplyRegistModal'
import serviceContentsApplySortModal from '@/store/components/modal/serviceContentsApplySortModal'

// modal : ファイル管理
import fileSelectServiceModal from '@/store/components/modal/fileSelectServiceModal'
// modal : BOT管理
import botDestinationModal from '@/store/components/modal/botDestinationModal'
// modal : アカウント管理
import accountSelectLinkedCmsModal from '@/store/components/modal/accountSelectLinkedCmsModal'
// modal : お知らせ管理
import noticeDeliveryStatusModal from '@/store/components/modal/noticeDeliveryStatusModal'
import noticeTestDeliveryModal from '@/store/components/modal/noticeTestDeliveryModal'
// modal : ログ管理
import logStatusModal from '@/store/components/modal/logStatusModal'
// modal : デバイス管理
import deviceRegistResolutionModal from '@/store/components/modal/deviceRegistResolutionModal'
// modal : ささえiでんわ管理
import videoChatModifyModal from '@/store/components/modal/videoChatModifyModal'


// ********************
// ScreenConfigLayout
// ********************

import screenConfigLayout from '@/store/components/screenConfigLayout/screenConfigLayout'
import screenConfigLayoutConst from '@/store/components/screenConfigLayout/screenConfigLayoutConst'
import sclHeaderModule from '@/store/components/screenConfigLayout/sclHeaderModule'
import sclSlideshowModule from '@/store/components/screenConfigLayout/sclSlideshowModule'
import sclWeatherModule from '@/store/components/screenConfigLayout/sclWeatherModule'
import sclFortuneModule from '@/store/components/screenConfigLayout/sclFortuneModule'
import sclCalenderModule from '@/store/components/screenConfigLayout/sclCalenderModule'
import sclButtonModule from '@/store/components/screenConfigLayout/sclButtonModule'
import sclListModule from '@/store/components/screenConfigLayout/sclListModule'
import sclLabelModule from '@/store/components/screenConfigLayout/sclLabelModule'
import sclImageModule from '@/store/components/screenConfigLayout/sclImageModule'
import sclPanelModule from '@/store/components/screenConfigLayout/sclPanelModule'
import sclZIndexModule from '@/store/components/screenConfigLayout/sclZIndexModule'



Vue.use(Vuex)



export default new Vuex.Store({
  modules: {
    // common
    config: config,
    auth: auth,
    meta: meta,
    core: core,
    permission: permission,
    admp: admp,


    // view
    dashboard: dashboard,
    // view : サービス管理
    service: service,
    serviceForm: serviceForm,
    file: file,
    bot: bot,
    // 202304 サービス管理に「外部パートナー連携」メニューを追加 ST
    partner: partner,
    partnerForm: partnerForm,
    // 202304 サービス管理に「外部パートナー連携」メニューを追加 ED
    // view : サービス詳細
    serviceDetail: serviceDetail,
    serviceDeliveryTerm: serviceDeliveryTerm,
    serviceDeliveryTermDetail: serviceDeliveryTermDetail,
    serviceAttribute: serviceAttribute,
    serviceAttributeDetail: serviceAttributeDetail,
    serviceFunction: serviceFunction,
    serviceFunctionDetail: serviceFunctionDetail,
    serviceMailMagazine: serviceMailMagazine,
    serviceLinkedCms: serviceLinkedCms,
    serviceRss: serviceRss,
    serviceDropbox: serviceDropbox,
    serviceContentsSetting: serviceContentsSetting,
    serviceContentsSettingForm: serviceContentsSettingForm,
    serviceScreenSetting: serviceScreenSetting,
    serviceScreenSettingForm: serviceScreenSettingForm,
    serviceContentsApply: serviceContentsApply,
    serviceLinkCategory: serviceLinkCategory,
    // view : マスタ管理
    deliveryTypeMst: deliveryTypeMst,
    noticeTypeMst: noticeTypeMst,
    linkedCmsMst: linkedCmsMst,
    screenConfigMst: screenConfigMst,
    screenIdMst: screenIdMst,
    spAppMst: spAppMst,
    // view : アカウント管理
    user: user,
    userForm: userForm,
    // view : お知らせ管理
    notice: notice,
    noticeForm: noticeForm,
    noticeDetail: noticeDetail,
    noticeList: noticeList,
    // view : ログ管理
    log: log,
    logDownload: logDownload,
    // view : ADMP連携管理
    tenant: tenant,
    tenantDetail: tenantDetail,
    community: community,
    communityDetail: communityDetail,
    communityLocation: communityLocation,
    device: device,
    // view : ささえiでんわ管理
    videoChat: videoChat,
    // view : ロケーション管理
    location: location,
    // view : お知らせ配信管理
    noticeCheck: noticeCheck,
    // view : core
    myAccount: myAccount,
    signin: signin,
    password: password,
    register: register,


    // components : dialog
    toast: toast,
    confirm: confirm,
    alert: alert,
    error: error,

    // components : modal : ダッシュボード
    dashboardRegistAdminNoticeModal: dashboardRegistAdminNoticeModal,
    dashboardConfirmAdminNoticeModal: dashboardConfirmAdminNoticeModal,
    // components : modal : マスタ管理
    selectNoticeTypeMstModal: selectNoticeTypeMstModal,
    selectServiceTypeModal: selectServiceTypeModal,
    selectScreenIdMstModal: selectScreenIdMstModal,
    // components : modal : サービス管理 : core
    selectFileModal: selectFileModal,
    selectServiceScreenModal: selectServiceScreenModal,
    selectServiceDeliveryTypeModal: selectServiceDeliveryTypeModal,
    selectServiceNoticeTypeModal: selectServiceNoticeTypeModal,
    selectServiceRssModal: selectServiceRssModal,
    selectVideoChatModal: selectVideoChatModal,
    // components : modal : サービス管理 :
    serviceRegistDeliveryTypeModal: serviceRegistDeliveryTypeModal,
    serviceRegistAttributeGroupModal: serviceRegistAttributeGroupModal,
    serviceSelectFunctionModal: serviceSelectFunctionModal,
    serviceRegistMailMagazineModal: serviceRegistMailMagazineModal,
    // components : modal : サービス管理 : コンテンツ設定
    serviceContentsCopyModal: serviceContentsCopyModal,
    serviceContentsRegistSnapshotModal: serviceContentsRegistSnapshotModal,
    serviceContentsRegistScreenModal: serviceContentsRegistScreenModal,
    serviceContentsRegistKeyAssignModal: serviceContentsRegistKeyAssignModal,
    selectServiceContentsScreenModal: selectServiceContentsScreenModal,
    // components : modal : サービス管理 : 適用コンテンツ設定
    serviceContentsApplyConfirmModal: serviceContentsApplyConfirmModal,
    serviceContentsApplyRegistModal: serviceContentsApplyRegistModal,
    serviceContentsApplySortModal: serviceContentsApplySortModal,
    // components : modal : ファイル管理
    fileSelectServiceModal: fileSelectServiceModal,
    // components : modal : BOT管理
    botDestinationModal: botDestinationModal,
    // components : modal : アカウント管理
    accountSelectLinkedCmsModal: accountSelectLinkedCmsModal,
    // components : modal : お知らせ管理
    noticeDeliveryStatusModal: noticeDeliveryStatusModal,
    noticeTestDeliveryModal: noticeTestDeliveryModal,
    // components : modal : ログ管理
    logStatusModal: logStatusModal,
    // components : modal : デバイス管理
    deviceRegistResolutionModal: deviceRegistResolutionModal,
    // components : modal : ささえiでんわ管理
    videoChatModifyModal: videoChatModifyModal,


    // screenConfigLayout
    screenConfigLayout: screenConfigLayout,
    screenConfigLayoutConst: screenConfigLayoutConst,
    sclHeaderModule: sclHeaderModule,
    sclSlideshowModule: sclSlideshowModule,
    sclWeatherModule: sclWeatherModule,
    sclFortuneModule: sclFortuneModule,
    sclCalenderModule: sclCalenderModule,
    sclButtonModule: sclButtonModule,
    sclListModule: sclListModule,
    sclLabelModule: sclLabelModule,
    sclImageModule: sclImageModule,
    sclPanelModule: sclPanelModule,
    sclZIndexModule: sclZIndexModule
  }
})